<template>
    <Paper id="IdentityManagementDetail">
        <div class="detailForm">
            <el-form :inline="true" :model="formInlineDetail" class="demo-form-inline detailForm-top">
                <el-form-item label="标识编码 : ">
                    <el-input :disabled="true" v-model="formInlineDetail.identityCode" placeholder="标识编码"></el-input>
                </el-form-item>
                <el-form-item label="产品名称 : ">
                    <el-input :disabled="true" v-model="formInlineDetail.productName" placeholder="产品名称"></el-input>
                </el-form-item>
                <el-form-item label="产品分类 ：">
                    <el-input :disabled="true" v-model="formInlineDetail.productTemplateName" placeholder="产品分类"></el-input>
                </el-form-item>
                <el-form-item label="跳转链接 : " v-if="formInlineDetail.link">
                    <el-input :disabled="true" v-model="formInlineDetail.link" placeholder="跳转链接"></el-input>
                </el-form-item>
            </el-form>
            <div v-if="!formInlineDetail.link">
                <p class="describeClass">产品属性 : </p>
                <div class="identificationattribute">
                    <!-- 动态展示 -->
                    <ul>
                        <li class="lispecific" v-for="(item, index) in formInlineLsit" :key="index">
                            <span>{{item.attributeName}}</span>
                            <span><el-input :disabled="true" v-model="item.attributeValue" :placeholder="item.attributeName"></el-input></span>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-if="!formInlineDetail.link&&spliceArray.length">
               <p class="describeClass">图片 : </p>
               <div class="detail-img">
                   <span v-for="(item, index) in imagesArray" :key="index" class="detail-img-span">
                       <img  @click="viewPhotos(item)" :src="item" alt="">
                    </span>
               </div>
            </div>
            <div v-if="!formInlineDetail.link&&videoArray.length">
                <p class="describeClass">视频 : </p>
                <div style="padding-left: 40px;">
                    <span class="detail-video">
                        <video
                            controls="controls"
                            :src="videoUrl"
                        ></video>
                    </span>
                </div>
            </div>
        </div>
    </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import { getList } from '../../../../api/IdentityInquire';
import Viewer from 'viewerjs';
export default {
    name: 'IdentityInquireDetail',
    components: { Paper },
    data() {
        return {
            formInlineDetail: {
                identityCode: '',
                productName: '',
                productTemplateName: '',
                link: ''
            },
            formInlineLsit: [],
            imagesArray: [],
            videoUrl: '',
            spliceArray: [],
            videoArray: []
        };
    },
    methods: {
        getListClick() {
            const params = [];
            params[0] = this.$route.query.message.tenantCode;
            params[1] = this.$route.query.message.prefixCode;
            params[2] = this.$route.query.message.identityCode;
            getList(params).then(res => {
                this.spliceArray = [];
                this.videoArray = [];
                if (res.code === '0') {
                    this.formInlineDetail['identityCode'] = res.data.identityCode;
                    this.formInlineDetail['productName'] = res.data.productName;
                    this.formInlineDetail['productTemplateName'] = res.data.productTemplateName;
                    this.formInlineDetail['link'] = res.data.link;
                    res.data.identityAttributes.map((item, index) => {
                        if (+item.attributeType === 2) {
                            this.spliceArray = res.data.identityAttributes.splice(index, 1);
                        }
                    });
                    res.data.identityAttributes.map((item, index) => {
                        if (+item.attributeType === 3) {
                            this.videoArray = res.data.identityAttributes.splice(index, 1);
                        }
                    });
                    this.formInlineLsit = res.data.identityAttributes;
                    this.getImgUrl(this.spliceArray, this.videoArray);
                }
            });
        },
        getImgUrl(params, data) {
            let imgArray = [];
            let videoUrl = [];
            this.imagesArray = [];
            if (params.length) {
                imgArray = params[0].attributeValue.split(',');
            };
            if (data.length) {
                videoUrl = data[0].attributeValue.split(',');
            };
            imgArray.map(item => {
                if (item) {
                    this.imagesArray.push(item);
                };
                return item;
            });
            videoUrl.map(item => {
                if (item) {
                    this.videoUrl = item;
                };
                return item;
            });
        },
        viewPhotos(item) {
            var image = new Image();
            image.src = item;
            var viewer = new Viewer(image, {
                hidden: function () {
                    viewer.destroy();
                },
                zIndex: 3000
            });
            viewer.show();
        }
    },
    mounted() {
        this.getListClick();
    },
    activated() {
        this.getListClick();
    }
};
</script>
<style lang="less">
#IdentityManagementDetail {
    .detailForm {
        overflow: scroll;
        .detailForm-top {
            .el-form-item__content {
                width: 16vw;
            }
            .el-form-item__label {
                font-size: 14px;
            }
        }
        .el-form--inline .el-form-item {
            margin-right: 60px;
        }
        .identificationattribute {
            margin-left: 70px;
            ul {
                display: flex;
                flex-wrap: wrap;
                .lispecific {
                    width: 30%;
                    display: flex;
                    margin-bottom: 1vh;
                }
                .lispecific span:nth-child(1) {
                    font-size: 14px;
                    color: #555757;
                    line-height: 30px;
                    margin-right: 10px;
                    width: 80px;
                    text-align: right;
                }
                .lispecific span:nth-child(2) {
                    width: 16vw;
                }
            }
        }
        .describeClass {
            font-size: 16px;
            color: #555757;
        }
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .detail-img {
            display: flex;
            width: 40vw;
            padding-left: 60px;
            .detail-img-span {
                height: 10vh;
                width: 10vh;
                margin: 0 20px;
                background: #e4e7ed;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    height: 98%;
                    width: 98%;
                }
            }
    }
    .detail-video {
        height: 18vh;
        display: inline-block;
        width: 20vw;
        video {
            height: 100%;
            width: 100%;
            object-fit:fill;
        }
    }
}
</style>